import { exec } from "jadelet"
export default exec(["button",{"click":{"bind":"cancel"}},["Cancel"]])